import React from 'react';
import * as flags from 'country-flag-icons/react/3x2';

interface CountryFlagProps {
    countryCode: string;
    width?: number;
    height?: number;
}

export function CountryFlag({ countryCode, width = 28, height = 20 }: CountryFlagProps) {
    const code = countryCode.toUpperCase().replace(/-/g, '_');

    const FlagComponent = (flags as any)[code];

    if (!FlagComponent) {
        return (
            <span
                style={{
                    display: 'inline-block',
                    width: `${width}px`,
                    height: `${height}px`,
                    backgroundColor: '#e0e0e0',
                    borderRadius: '2px',
                }}
            />
        );
    }

    return (
        <span
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: `${width}px`,
                height: `${height}px`,
                borderRadius: '2px',
                overflow: 'hidden',
                boxShadow: '0 0 0 1px rgba(0,0,0,0.1)',
            }}
        >
            <FlagComponent style={{ width: '100%', height: '100%', display: 'block' }} />
        </span>
    );
}
